/**
 * Created by lhkj on 16/12/9.
 */
require('./index.scss');
require('common/header/header.js');
require('common/css/footer.scss');/*
const ChinaMap = require('common/map/china.js');
const BaiduMap = require('common/map/baidu.js');*/

$(function(){
  //获取dom元素
  var el1 = document .getElementById('china-map'),
  el2 = document .getElementById('map-info'),
  nav = $('.nav-box'),
  navOffsetTop = $('.tab-nav').offset().top,
  storeInfo = $('.store-info'),
  //storeTop = $('#china-map').offset().top,
  name = $('.name'),
  address = $('.address'),
  phone = $('.phone'),
  time = $('.time');

 var main = {
      init: function () {
          this.bindEvent();
      },

      bindEvent: function () {

        // 设置导航吸顶效果
        $(window).on('scroll', function () {
          nav.css('position', navOffsetTop <= (window.scrollY || document.body.scrollTop || document.documentElement.scrollTop) ? 'fixed' : 'absolute');
        });

        //导航高亮切换
        nav.on('click', 'li', function () {
            var act = 'active-li';
            $(this).addClass(act).siblings().removeClass(act);
        });

        /*//初始化生成中国地图
        var branchMap = ChinaMap.create(el1);

        //点击生成百度地图
        branchMap.on('tooltipclick', function (el) {
          if($('.store-info').is(':hidden')){
            $('.store-info').show();
          }
          var data = $(el).data();

          BaiduMap.create({
            container: el2,
            pointX: data.pointx,
            pointY: data.pointy,
            searchTitle: data.title,
            searchContent: data.address,
          });
         
          
          name.text(data.name);
          address.text(data.address);
          phone.text(data.phone);
          time.text(data.time);
          $('body,html').animate({
              scrollTop:storeTop+646,
          }, 200);
        });*/
     
      },
  };
  main.init();
});
     
          




// WEBPACK FOOTER //
// ./static/about/index.js